<template>
  <a-modal 
    v-model="visible" 
    :title="$t('filePointFilterTitle')" 
    width="800px" 
    :okText="$t('confirm')" 
    :cancelText="$t('cancel')" 
    :maskClosable="false" 
    @ok="ok"
  >
    <div class="checkbox-actions">
      <a-button type="link" @click="selectAll">{{ $t('selectAll') }}</a-button>
      <a-button type="link" @click="deselectAll">{{ $t('deselectAll') }}</a-button>
    </div>
    <a-checkbox-group v-model="value">
      <a-row>
        <a-col :span="12" v-for="item in list" :key="item.key">
          <a-checkbox :key="item.key" :value="item.key">{{ item.name }}</a-checkbox>
        </a-col>
      </a-row>
    </a-checkbox-group>
  </a-modal>
</template>

<script>
export default {
  name: 'FilePointFilterModal',
  components: {},
  data() {
    return {
      visible: false,
      value: [],
      list: []
    }
  },
  methods: {
    open(list){
      this.list = list;
      // 默认全选
      this.value = this.list.map(item=> item.key );
      // console.log(this.list)
      // console.log(this.value)
      this.visible = true;
    },
    ok(){
      this.$emit('ok', this.value)
      this.list = [];
      this.value = [];
      this.visible = false;
    },
    selectAll() {
      this.value = this.list.map(item => item.key);
    },
    deselectAll() {
      this.value = [];
    }
  }
}
</script>

<style scoped lang="scss">
.checkbox-actions {
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
}
</style>